const skipLink = document.querySelector('.js-skip-link');
const main = document.querySelector('#main');

skipLink.addEventListener('click', function() {
  main.setAttribute('tabindex', '-1');
  main.focus();
});
